// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f8012a48","109":"bae780d3","476":"fa10727a","522":"ac2c675b","620":"4d148005"}[chunkId] + ".chunk.js";
};